var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "topbar" }, [
        _c("i", { on: { click: _vm.goHome } }),
        _vm._v(" "),
        _c("div", { staticClass: "mainBox1" }, [
          _c(
            "div",
            {
              staticClass: "changeLangBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.moreLang()
                }
              }
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("language")) + "\n          "
              ),
              _vm.$i18n.locale != "he"
                ? _c("em", { staticClass: "iconfont icon-een" })
                : _vm._e(),
              _vm._v(" "),
              _vm.$i18n.locale != "he"
                ? _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.changeLangBox,
                          expression: "changeLangBox"
                        }
                      ],
                      staticClass: "chooseLangUl"
                    },
                    _vm._l(_vm.langList, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "chooseLangUlli",
                          on: {
                            click: function($event) {
                              _vm.setLanguage(item.id)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.name) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  )
                : _vm._e()
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox" }, [
        _vm.showVIPType == 12
          ? _c("div", { staticClass: "signInBox" }, [
              _c("div", { staticClass: "forgetPsd1" }, [
                _vm._v(_vm._s(_vm.$t("annual_membership")))
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "line-height": "150%",
                    "font-size": "160%",
                    color: "#37c2e5"
                  }
                },
                [_vm._v("请扫描或长按识别下方二维码")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "line-height": "150%",
                    "font-size": "160%",
                    color: "#37c2e5"
                  }
                },
                [_vm._v("购买ICode年费会员")]
              ),
              _vm._v(" "),
              _c("img", {
                staticStyle: { "margin-top": "10%" },
                attrs: { src: _vm.imgurl, alt: "" }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.s1Showpwd,
                      expression: "s1Showpwd"
                    }
                  ],
                  staticClass: "s1",
                  attrs: { id: "france" }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("signup_txt7")) +
                      "\n          "
                  )
                ]
              )
            ])
          : _vm.showVIPType == 3
          ? _c("div", { staticClass: "signInBox" }, [
              _c("div", { staticClass: "forgetPsd1" }, [
                _vm._v(
                  _vm._s(
                    _vm.schoolId == "433756"
                      ? "模拟训练季卡"
                      : _vm.$t("season_membership")
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "line-height": "150%",
                    "font-size": "160%",
                    color: "#37c2e5"
                  }
                },
                [_vm._v("请扫描或长按识别下方二维码")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "line-height": "150%",
                    "font-size": "160%",
                    color: "#37c2e5"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.schoolId == "433756"
                        ? "购买模拟训练季卡"
                        : "购买ICode季度会员"
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c("img", {
                staticStyle: { "margin-top": "10%" },
                attrs: { src: _vm.imgurl, alt: "" }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.s1Showpwd,
                      expression: "s1Showpwd"
                    }
                  ],
                  staticClass: "s1",
                  attrs: { id: "france" }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("signup_txt7")) +
                      "\n          "
                  )
                ]
              )
            ])
          : _c("div", { staticClass: "signInBox" }, [
              _c("div", { staticClass: "forgetPsd1" }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "line-height": "150%",
                    "font-size": "160%",
                    color: "#37c2e5"
                  }
                },
                [_vm._v("暂时无法购买会员")]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("img", {
                staticStyle: { "margin-top": "10%" },
                attrs: { src: "", alt: "" }
              }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.s1Showpwd,
                    expression: "s1Showpwd"
                  }
                ],
                staticClass: "s1",
                attrs: { id: "france" }
              })
            ])
      ]),
      _vm._v(" "),
      _c("LeapPopup", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.maskBox,
            expression: "maskBox"
          }
        ],
        attrs: {
          title: _vm.$t("timeout01"),
          content: _vm.$t("timeout02"),
          cancelButtonTxt: _vm.$t("timeout04"),
          okButtonTxt: _vm.$t("timeout03"),
          isConfirm: false
        },
        on: { onOK: _vm.logOut }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticStyle: {
          "line-height": "150%",
          "font-size": "160%",
          color: "#37c2e5"
        }
      },
      [
        _vm._v("请前往"),
        _c(
          "a",
          {
            staticStyle: { color: "white" },
            attrs: { href: "https://home.icode.org.cn/wechat" }
          },
          [_vm._v("学习平台")]
        ),
        _vm._v("咨询客服")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30c06fa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c06fa6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/renew.vue
// module id = null
// module chunks = 